import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdiminibus() {



  const cardData = {
"keyword": "Pune to Shirdi Mini Bus",

"headingDescription":
  "Aaradhya Travels offers reliable Pune to Shirdi Mini Bus service for family trips, Sai Baba darshan tours, group pilgrimage travel, corporate outings, and comfortable outstation journeys. Our fleet includes 14, 17, 20, 25, 32, and 35-seater mini buses equipped with air-conditioning, pushback seats, spacious interiors, and professional drivers experienced on Pune to Shirdi highway routes. We provide safe, comfortable, and punctual transportation with doorstep pickup from Pune city, airport, railway stations, hotels, and residential areas for smooth Shirdi group travel.",

"topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description":
      "Shirdi Sai Baba Temple is one of India’s most visited pilgrimage destinations attracting devotees from across the country for spiritual darshan and temple visits."
  },
  {
    "title": "Sai Baba Samadhi Mandir",
    "description":
      "Sai Baba Samadhi Mandir is the main temple complex in Shirdi where devotees gather for darshan, prayers, and religious ceremonies."
  },
  {
    "title": "Dwarkamai",
    "description":
      "Dwarkamai is a sacred place associated with Sai Baba’s life and teachings, visited by pilgrims during the Shirdi temple tour."
  },
  {
    "title": "Chavadi",
    "description":
      "Chavadi is an important spiritual site in Shirdi where Sai Baba used to rest on alternate nights and is part of the pilgrimage route."
  },
  {
    "title": "Sai Heritage Village",
    "description":
      "Sai Heritage Village is a cultural attraction near Shirdi showcasing the life and teachings of Sai Baba through exhibits and village recreations."
  },
  {
    "title": "Kopargaon",
    "description":
      "Kopargaon is a nearby town and railway connection point for Shirdi frequently included in Pune to Shirdi travel routes."
  },
  {
    "title": "Ahmednagar Highway",
    "description":
      "Ahmednagar Highway is the primary route used for Pune to Shirdi mini bus travel offering smooth highway connectivity for outstation journeys."
  },
  {
    "title": "Ranjangaon Mahaganpati",
    "description":
      "Ranjangaon Mahaganpati Temple is an important Ashtavinayak temple located on the Pune–Ahmednagar route often visited during Shirdi trips."
  },
  {
    "title": "Narayangaon",
    "description":
      "Narayangaon is a town on the Pune–Nashik route frequently included as a stopover point during group travel towards Shirdi."
  },
  {
    "title": "Sinnar",
    "description":
      "Sinnar near Nashik is an industrial and highway town commonly crossed during Pune to Shirdi outstation journeys."
  },
  {
    "title": "Nashik",
    "description":
      "Nashik is a major pilgrimage and tourist city near Shirdi often combined with Sai Baba darshan tours and Trimbakeshwar visits."
  },
  {
    "title": "Trimbakeshwar Temple",
    "description":
      "Trimbakeshwar Temple near Nashik is one of the twelve Jyotirlingas and a popular spiritual destination often added to Shirdi group tours."
  },
  {
    "title": "Pune Railway Station",
    "description":
      "Pune Railway Station is a major pickup point for groups and pilgrims traveling from Pune to Shirdi by mini bus."
  },
  {
    "title": "Pune Airport",
    "description":
      "Pune Airport serves as an important pickup and drop location for devotees and tourists planning Shirdi travel."
  },
  {
    "title": "Wagholi",
    "description":
      "Wagholi is a major suburb on the Pune–Ahmednagar route commonly included in pickup services for Pune to Shirdi travel."
  },
  {
    "title": "Kharadi",
    "description":
      "Kharadi is a major IT and residential area in Pune frequently included in group pickup routes for Shirdi journeys."
  },
  {
    "title": "Viman Nagar",
    "description":
      "Viman Nagar near Pune Airport is a popular pickup location for family groups and pilgrims traveling to Shirdi."
  },
  {
    "title": "Hadapsar",
    "description":
      "Hadapsar is a key Pune locality connected to the Ahmednagar Highway and frequently included in mini bus pickup services."
  },
  {
    "title": "Alandi",
    "description":
      "Alandi is a famous pilgrimage town near Pune associated with Sant Dnyaneshwar Maharaj and often combined with spiritual travel routes."
  },
  {
    "title": "Bhakti Spiritual Journey Route",
    "description":
      "The Pune to Shirdi route offers a peaceful spiritual travel experience connecting devotees with important temples, religious landmarks, and pilgrimage destinations across Maharashtra."
  }
],



services: [
  {
    name: "Pune to Shirdi Mini Bus on Rent",
    description: "Pune to Shirdi mini bus on rent service provides comfortable transportation for Sai Baba darshan tours, pilgrimage journeys, family trips, and spiritual group travel. Spacious seating and smooth highway travel ensure pleasant journeys suitable for devotees and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi mini bus reservations."
  },
  {
    name: "Pune to Shirdi Bus Hire",
    description: "Pune to Shirdi bus hire service offers dependable transportation for Sai Baba temple visits, family travel, pilgrimage tours, and group darshan journeys. Spacious buses ensure smooth highway travel suitable for spiritual tourism and outstation travel requirements. Professional drivers ensure punctual pickup and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi bus hire reservations."
  },
  {
    name: "Shirdi Darshan Mini Bus Pune",
    description: "Shirdi darshan mini bus Pune service provides reliable transportation for devotees planning temple visits, spiritual journeys, and religious tours to Shirdi from Pune. Comfortable seating and spacious interiors ensure pleasant travel experiences suitable for families and pilgrimage groups. Professional chauffeurs ensure safe driving and dependable transportation throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Shirdi darshan mini bus reservations."
  },
  {
    name: "Shirdi Trip Mini Bus Booking",
    description: "Shirdi trip mini bus booking service offers comfortable transportation for Sai Baba pilgrimage journeys, family vacations, group darshan tours, and spiritual travel requirements. Spacious seating and luggage capacity ensure smooth travel experiences suitable for all passenger groups. Professional drivers ensure punctual transportation and safe driving services throughout the Shirdi journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi trip mini bus reservations."
  },
  {
    name: "AC Mini Bus Pune to Shirdi",
    description: "AC mini bus Pune to Shirdi service provides premium air-conditioned transportation for temple visits, pilgrimage tours, and family travel to Shirdi. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions and long-distance journeys. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC Shirdi mini bus reservations."
  },
  {
    name: "Non AC Mini Bus Pune to Shirdi",
    description: "Non AC mini bus Pune to Shirdi service offers affordable transportation for Sai Baba darshan trips, group travel, educational tours, and family pilgrimage journeys. Spacious buses ensure comfortable highway travel suitable for budget-friendly outstation travel requirements. Professional drivers ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient non AC Shirdi mini bus reservations."
  },
  {
    name: "17 Seater Pune to Shirdi Bus",
    description: "17 seater Pune to Shirdi bus service provides spacious transportation for medium-sized pilgrimage groups, family trips, and Sai Baba darshan tours. Comfortable seating and luggage space ensure smooth travel experiences suitable for outstation journeys and temple visits. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 17 seater Shirdi bus reservations."
  },
  {
    name: "25 Seater Shirdi Bus Hire",
    description: "25 seater Shirdi bus hire service offers reliable transportation for large pilgrimage groups, family gatherings, educational tours, and spiritual travel to Sai Baba temple from Pune. Spacious interiors and comfortable seating ensure pleasant journeys suitable for group travel requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient 25 seater Shirdi bus reservations."
  },
  {
    name: "Shirdi Outstation Mini Bus Pune",
    description: "Shirdi outstation mini bus Pune service provides dependable long-distance transportation for Sai Baba pilgrimage journeys, religious tourism, family vacations, and group travel. Spacious buses ensure comfortable highway travel suitable for local and outstation spiritual tours. Professional chauffeurs ensure reliable transportation and safe driving services throughout the Shirdi route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Shirdi outstation mini bus reservations."
  },
  {
    name: "Pune to Shirdi Family Trip Bus",
    description: "Pune to Shirdi family trip bus service offers comfortable transportation for family darshan tours, holiday travel, pilgrimage journeys, and group spiritual visits. Spacious seating and luggage capacity ensure smooth travel experiences suitable for families and senior citizens. Professional chauffeurs ensure safe driving and dependable transportation throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient family trip bus reservations."
  },
  {
    name: "Pune to Shirdi Group Travel Bus",
    description: "Pune to Shirdi group travel bus service provides spacious transportation for pilgrimage groups, educational tours, office outings, and family darshan journeys. Comfortable buses ensure smooth highway travel suitable for large passenger groups and spiritual travel requirements. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient group travel bus reservations."
  },
  {
    name: "Shirdi Temple Visit Bus Hire",
    description: "Shirdi temple visit bus hire service offers reliable transportation for Sai Baba darshan tours, religious travel, and family pilgrimage journeys from Pune. Spacious buses ensure smooth travel suitable for spiritual tourism and temple visit requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient temple visit bus reservations."
  },
  {
    name: "Shirdi Round Trip Mini Bus Pune",
    description: "Shirdi round trip mini bus Pune service provides comfortable two-way transportation for Sai Baba temple visits, family darshan tours, and pilgrimage travel requirements. Spacious seating and smooth highway travel ensure pleasant journeys suitable for group and family travel. Professional drivers ensure safe driving and dependable transportation services throughout the round trip journey. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient round trip mini bus reservations."
  },
  {
    name: "Cheap Pune to Shirdi Bus Rental",
    description: "Cheap Pune to Shirdi bus rental service offers economical transportation for pilgrimage tours, family darshan journeys, educational travel, and group temple visits. Spacious buses ensure comfortable travel suitable for budget-friendly outstation transportation requirements. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient affordable Shirdi bus reservations."
  },
  {
    name: "Luxury Pune to Shirdi Mini Bus",
    description: "Luxury Pune to Shirdi mini bus service offers premium transportation with spacious interiors and elegant seating for Sai Baba pilgrimage journeys and family darshan tours. Comfortable luxury buses ensure smooth travel experiences suitable for VIP passengers and group travel. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, luxury hotels, airports, and offices across Pune. Flexible booking options allow convenient luxury Shirdi mini bus reservations."
  },
  {
    name: "Private Shirdi Bus from Pune",
    description: "Private Shirdi bus from Pune service provides exclusive transportation for family pilgrimage tours, temple visits, spiritual travel, and personalized group journeys. Spacious buses ensure smooth and private travel suitable for families, tourists, and religious groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient private Shirdi bus reservations."
  },
  {
    name: "Pune to Shirdi Tempo Traveller Alternative",
    description: "Pune to Shirdi Tempo Traveller alternative service offers spacious mini bus transportation suitable for larger pilgrimage groups, family tours, and spiritual journeys. Comfortable seating and luggage space ensure pleasant travel experiences suitable for outstation darshan trips. Professional chauffeurs ensure reliable transportation and safe driving services throughout the Shirdi route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient Shirdi mini bus reservations."
  },
  {
    name: "Shirdi Pilgrimage Bus Pune",
    description: "Shirdi pilgrimage bus Pune service provides dependable transportation for devotees planning Sai Baba darshan tours, spiritual travel, and family pilgrimage journeys. Spacious buses ensure smooth highway travel suitable for religious tourism and temple visit requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient pilgrimage bus reservations."
  },
  {
    name: "One Day Shirdi Tour Bus Pune",
    description: "One day Shirdi tour bus Pune service offers reliable transportation for same-day Sai Baba darshan tours, family temple visits, and group pilgrimage journeys. Comfortable seating and smooth travel ensure pleasant experiences suitable for short religious travel schedules. Professional chauffeurs ensure timely transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient one day Shirdi tour bus reservations."
  },
  {
    name: "Pune to Shirdi Tourist Bus Hire",
    description: "Pune to Shirdi tourist bus hire service provides comfortable transportation for sightseeing tours, Sai Baba temple visits, pilgrimage travel, and family vacations. Spacious buses ensure smooth highway travel suitable for tourists, devotees, and group travelers. Professional drivers ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient tourist bus hire reservations."
  },
  {
    name: "Shirdi AC Bus Booking Pune",
    description: "Shirdi AC bus booking Pune service offers premium air-conditioned transportation for Sai Baba pilgrimage tours, family darshan visits, and outstation journeys. Comfortable seating and cooling systems ensure smooth travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient AC Shirdi bus reservations."
  },
  {
    name: "Shirdi Package Bus Pune",
    description: "Shirdi package bus Pune service provides dependable transportation for Sai Baba temple tour packages, spiritual travel plans, and family pilgrimage journeys. Spacious buses ensure comfortable travel suitable for complete darshan packages and group travel requirements. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi package bus reservations."
  },
  {
    name: "Door Pickup Pune to Shirdi Bus",
    description: "Door pickup Pune to Shirdi bus service offers convenient transportation with home pickup facilities for Sai Baba pilgrimage journeys, family darshan trips, and spiritual travel. Comfortable buses ensure smooth highway travel suitable for local and outstation temple visits. Professional chauffeurs ensure punctual pickup and reliable transportation services throughout the route. Pickup services are available directly from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient door pickup bus reservations."
  },
  {
    name: "Shirdi Return Bus Pune",
    description: "Shirdi return bus Pune service provides comfortable round-trip transportation for Sai Baba darshan tours, pilgrimage journeys, and family temple visits from Pune. Spacious seating and smooth travel ensure pleasant return journeys suitable for all passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient Shirdi return bus reservations."
  },
  {
    name: "Pune to Shirdi Travel Service",
    description: "Pune to Shirdi travel service offers dependable transportation for Sai Baba pilgrimage journeys, spiritual travel, family vacations, and group temple tours. Spacious buses ensure smooth highway travel suitable for devotees, tourists, and outstation travelers. Professional chauffeurs ensure safe driving and reliable transportation services throughout the Shirdi route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Shirdi travel service reservations."
  }
],

tableData: [
  ["Pune to Shirdi Mini Bus on Rent", "Pune to Shirdi Bus Hire"],
  ["Shirdi Darshan Mini Bus Pune", "Shirdi Trip Mini Bus Booking"],
  ["AC Mini Bus Pune to Shirdi", "Non AC Mini Bus Pune to Shirdi"],
  ["17 Seater Pune to Shirdi Bus", "25 Seater Shirdi Bus Hire"],
  ["Shirdi Outstation Mini Bus Pune", "Pune to Shirdi Family Trip Bus"],
  ["Pune to Shirdi Group Travel Bus", "Shirdi Temple Visit Bus Hire"],
  ["Shirdi Round Trip Mini Bus Pune", "Cheap Pune to Shirdi Bus Rental"],
  ["Luxury Pune to Shirdi Mini Bus", "Private Shirdi Bus from Pune"],
  ["Pune to Shirdi Tempo Traveller Alternative", "Shirdi Pilgrimage Bus Pune"],
  ["One Day Shirdi Tour Bus Pune", "Pune to Shirdi Tourist Bus Hire"],
  ["Shirdi AC Bus Booking Pune", "Shirdi Package Bus Pune"],
  ["Door Pickup Pune to Shirdi Bus", "Shirdi Return Bus Pune"],
  ["Pune to Shirdi Travel Service", "Pune to Shirdi Mini Bus on Rent"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Shirdi Mini Bus Service",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to Shirdi mini bus service with comfortable vehicles, professional drivers, and smooth travel arrangements for family trips, Sai Baba darshan tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable Shirdi Mini Bus Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to Shirdi mini bus rental packages with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Mini Bus Booking for Shirdi Travel",
        WhyChoosedescription: "Our Pune to Shirdi mini bus service operates 24 hours for Sai Baba darshan tours, family pilgrimages, weekend trips, corporate outings, and group travel requirements."
      },
      {
        WhyChooseheading: "Comfortable AC & Non-AC Mini Buses",
        WhyChoosedescription: "All mini buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for safe and comfortable Shirdi travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Shirdi Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day Shirdi darshan trips, weekend pilgrimage tours, and multi-day outstation travel packages according to customer requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Mini Bus Options",
        WhyChoosedescription: "Customers can choose from 14 seater, 17 seater, 20 seater, 25 seater, and larger mini buses suitable for families, senior citizens, tourist groups, and corporate teams."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, hotels, Pune Airport, railway stations, and major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely arrival for Sai Baba darshan and group travel requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Shirdi mini bus service?", answer: "Pune to Shirdi mini bus service provides comfortable group transportation for Sai Baba darshan, family tours, and pilgrimage travel." },
    { question: "Is Pune to Shirdi mini bus booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 mini bus booking service from Pune to Shirdi." },
    { question: "Which mini bus seating options are available for Shirdi travel?", answer: "Aaradhya Travels offers 14 seater, 17 seater, 20 seater, and 25 seater mini buses for group travel requirements." },
    { question: "Can I book mini bus for one-day Shirdi trip?", answer: "Yes, customers can book one-day as well as multi-day Shirdi mini bus tour packages." },
    { question: "Do you provide AC and Non-AC mini buses for Shirdi travel?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC mini buses for comfortable and budget-friendly pilgrimage travel." },
    { question: "Can I book Pune to Shirdi mini bus online?", answer: "Yes, customers can easily book mini bus service online or through phone booking." },
    { question: "Do you provide mini buses for family and group pilgrimage tours?", answer: "Yes, Aaradhya Travels provides spacious mini buses suitable for families, senior citizens, and group darshan travel." },
    { question: "Are Pune to Shirdi mini bus charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Shirdi mini bus service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Vijay Deshmukh",
    feedback:
      "The Pune to Shirdi trip with Aaradhya Travels in a mini bus was very comfortable and well organized. The journey felt peaceful, and the group could travel together without any inconvenience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Kulkarni",
    feedback:
      "Aaradhya Travels arranged a mini bus for our Pune to Shirdi pilgrimage, and the experience was smooth from start to finish. The ride was comfortable, and the travel coordination was excellent.",
    rating: 5
  }
];







  


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Mini Bus",
  "image": "https://www.aaradhyatravels99.com/assets/images/pune-to-shirdi-mini-bus.jpg",
  "description": "Book Pune to Shirdi Mini Bus with Aaradhya Travels for comfortable pilgrimage travel. Available AC and Non-AC mini buses including 17 and 25 seater options for Shirdi darshan, family trips, and group tours from Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5284"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/pune-to-shirdi-mini-bus"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Shirdi Mini Bus | AC & Non-AC Bus Hire for Darshan | +91 9529697070
  </title>

  <meta
    name="description"
    content="Book Pune to Shirdi Mini Bus with Aaradhya Travels. Affordable AC and Non-AC mini bus options including 17 and 25 seater vehicles for Shirdi darshan, family trips, group tours, and outstation travel from Pune."
  />

  <meta
    name="keywords"
    content="Pune to Shirdi mini bus on rent, Pune to Shirdi bus hire, Shirdi darshan mini bus Pune, Shirdi trip mini bus booking, AC mini bus Pune to Shirdi, Non AC mini bus Pune to Shirdi, 17 seater Pune to Shirdi bus, 25 seater Shirdi bus hire, Shirdi outstation mini bus Pune, Pune to Shirdi family trip bus, Pune to Shirdi group"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdiminibus;